var Common = {
  currentUser: JSON.parse(localStorage.getItem('userData')),
  isOn: localStorage.getItem('isOn'),
  baseUrl: 'https://emg.afripulse.cloud/',
  baseApiUrl: 'https://emg.afripulse.cloud/api/'
};
export default Common;